import { useEffect, useState } from "react";
import {
  IPdfAnnotations,
  PopoverConfiguration,
} from "~/typings/annotate/annotation";
import { PDFAnnotator } from "../pdf-annotator";

export function PDFAnnotatorWrapperClient(props: {
  fileUrl: string;
  id: string;
  annotations: IPdfAnnotations;
  // onPageChange?: (pageNumber: Number) => Promise<any>;
  // styleFile: string;
  popoverConfiguration: PopoverConfiguration;
  // openAtPage?: number;
  // endOfActions?: JSX.Element;
}) {
  const [client, setClient] = useState(false);
  useEffect(() => {
    setClient(true);
  }, []);
  return client ? <PDFAnnotator {...props} /> : null;
}
